import { type AttributeValue } from "../../attribute/AttributeSet";
import { type UserAttributeSet, UserAttributeType } from "../UserAttributeSet";

import { attributeListToMap } from "@/utils/attributes";

export enum RelationshipStatus {
  ASK_ME = "ask_me",
  COMPLICATED = "complicated",
  DATING = "dating",
  ENGAGED = "engaged",
  EXCLUSIVE = "exclusive",
  IN_A_RELATIONSHIP = "in_a_relationship",
  MARRIED = "married",
  OPEN_RELATIONSHIP = "open_relationship",
  OTHER = "other",
  PARTNERED = "partnered",
  SINGLE = "single",
}

const RELATIONSHIP_ATTRIBUTE_VALUES: ReadonlyArray<AttributeValue> = [
  { id: RelationshipStatus.ASK_ME, label: "Ask Me", iconLabel: "❓" },
  { id: RelationshipStatus.COMPLICATED, label: "Complicated", iconLabel: "🤔" },
  { id: RelationshipStatus.DATING, label: "Dating", iconLabel: "💑" },
  { id: RelationshipStatus.ENGAGED, label: "Engaged", iconLabel: "💍" },
  { id: RelationshipStatus.EXCLUSIVE, label: "Exclusive", iconLabel: "🔒" },
  {
    id: RelationshipStatus.IN_A_RELATIONSHIP,
    label: "In a Relationship",
    iconLabel: "❤️",
  },
  { id: RelationshipStatus.MARRIED, label: "Married", iconLabel: "💒" },
  {
    id: RelationshipStatus.OPEN_RELATIONSHIP,
    label: "Open Relationship",
    iconLabel: "🔓",
  },
  { id: RelationshipStatus.OTHER, label: "Other", iconLabel: "🔹" },
  { id: RelationshipStatus.PARTNERED, label: "Partnered", iconLabel: "🤝" },
  { id: RelationshipStatus.SINGLE, label: "Single", iconLabel: "🙋" },
];

export const UserRelationshipAttributeSet: Readonly<UserAttributeSet> = {
  id: UserAttributeType.RELATIONSHIP,
  isMultiSelect: false,
  map: attributeListToMap(RELATIONSHIP_ATTRIBUTE_VALUES),
} as const;
